import { WidgetComingSoon } from 'features/widgets/Widget';

const CompanyLicenses = () => {
  return <WidgetComingSoon title='Company Licenses' />;
};

export default CompanyLicenses;
